import React from "react";
import PropTypes from "prop-types";
import "./IconWithBackground.scss";
import { darkBlue } from "styles/colors.module.scss";

function IconWithBackground(props) {
  const { className, icon, backgroundColor, ...rest } = props;
  return (
    <div
      className={`icon-with-background ${className}`}
      style={{ background: backgroundColor }}
      {...rest}
    >
      {icon}
    </div>
  );
}

IconWithBackground.propTypes = {
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
};

IconWithBackground.defaultProps = {
  className: "",
  backgroundColor: darkBlue,
};
export default IconWithBackground;
